import { green, grey, lightGreen, teal } from '@material-ui/core/colors';

export const Gray = grey[600];

// primary color
export const primaryMain = '#17BAFF';
export const primaryLight = '#d2eeff';
export const primaryDark = '#20A6FC';
export const primarycontrastText = '#fff';

// secondary color
export const secondaryMain = '#fff';
export const secondaryLight = lightGreen.A400;
export const secondaryDark = '#f7f7f7';
export const secondarycontrastText = teal[400];

// Text colors
export const primaryTextColor = '#40576A';
export const secondryTextColor = '#b3bcc3';
export const secondryTextColorDark = '#1773BF';

// theme text color (primary,secondry)
export const textSecondaryColor = '#000';

// spinner color
export const spinnerColor = green[500];
